module.exports = __webpack_public_path__ + "img/enviar.a4ca29e9.png";